import { render } from "./BaseCollectionForm.vue?vue&type=template&id=0da32948"
import script from "./BaseCollectionForm.vue?vue&type=script&lang=js"
export * from "./BaseCollectionForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__